import { ReactElement, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

type Props = {
	children: ReactElement;
};

const ScrollToTop = ({ children }: Props) => {
	const location = useLocation();
	const scrollRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const scrollContainer = scrollRef.current?.querySelector(".layout__page");

		if (scrollContainer) {
			scrollContainer.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		} else {
			window.scrollTo({ top: 0, behavior: "smooth" });
		}
	}, [location.pathname]);

	return <div ref={scrollRef}>{children}</div>;
};

export default ScrollToTop;
